import React from 'react';
import { connect } from 'react-redux';
import EnumSelectorBase from './EnumSelectorBase';

const EquipmentTypeSelector = ({ equipTypes, value, setValue, sortOptions, renderOption }) => (
  <EnumSelectorBase
    name="Equipment Type"
    options={Object.values(equipTypes).sort(sortOptions)}
    getOptionLabel={(option) => option?.tagName || option}
    isOptionEqualToValue={(option, v) => option.id === v}
    value={value}
    onChange={setValue}
    renderOption={renderOption}
  />
);

export default connect(
  ({
    entities: {
      equipTypes: { byId: equipTypes },
    },
  }) => ({
    equipTypes,
  })
)(EquipmentTypeSelector);
